export default {"src":"/_next/static/media/SnapChat.c65f131f.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};